import React from 'react'
import { Checkbox } from 'antd'

const BulkSelectAll = (props) => {
    const {selectedAll, listSelected, loadingAction} = props

    const _handleSelectAll = () => {
        props.toggleSelectAll(!selectedAll)
    }

    return (
        <th className='BulkSelect position-relative'>
            <Checkbox disabled={loadingAction} indeterminate={!selectedAll && listSelected.length > 0} onChange={_handleSelectAll} checked={props.selectedAll}/>
        </th>
    )
}

export default BulkSelectAll
